import { render, staticRenderFns } from "./ProjectsTable.vue?vue&type=template&id=7f465138&"
import script from "./ProjectsTable.vue?vue&type=script&lang=js&"
export * from "./ProjectsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f465138')) {
      api.createRecord('7f465138', component.options)
    } else {
      api.reload('7f465138', component.options)
    }
    module.hot.accept("./ProjectsTable.vue?vue&type=template&id=7f465138&", function () {
      api.rerender('7f465138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Tables/ProjectsTable.vue"
export default component.exports